import { useEffect, useState } from 'react';

// Sticky in-page section rail for long admin forms — UserEdit is six stacked
// cards ~500px apart with no way to navigate between them (brief §6.4).
// Scrollspy via IntersectionObserver: the rootMargin band keeps exactly one
// section lit as the reader moves, rather than flickering between neighbours.
//
// Hidden under 1200px in CSS, so this is purely additive on narrow viewports.
export default function AdminSectionNav({ sections }) {
  const [activeId, setActiveId] = useState(sections[0]?.id);

  useEffect(() => {
    const nodes = sections
      .map((s) => document.getElementById(s.id))
      .filter(Boolean);
    if (!nodes.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 },
    );

    nodes.forEach((n) => observer.observe(n));
    return () => observer.disconnect();
  }, [sections]);

  return (
    <nav className="adm-toc" aria-label="Sections">
      {sections.map((s) => (
        <a
          key={s.id}
          href={`#${s.id}`}
          className={[
            'adm-toc__link',
            s.danger ? 'is-danger' : '',
            activeId === s.id ? 'is-active' : '',
          ].filter(Boolean).join(' ')}
          aria-current={activeId === s.id ? 'true' : undefined}
        >
          {s.label}
        </a>
      ))}
    </nav>
  );
}
